import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class RefreshService {
  public wasRefreshed = false;
  private readonly REFRESH_REASON_KEY = 'app_refresh_reason';

  public setWasRefreshed(browserRefreshed: boolean) {
    this.wasRefreshed = browserRefreshed;
  }

  public setRefreshReason(reason: string): void {
    sessionStorage.setItem(this.REFRESH_REASON_KEY, reason);
  }

  public getRefreshReason(): string | null {
    return sessionStorage.getItem(this.REFRESH_REASON_KEY);
  }

  public clearRefreshReason(): void {
    sessionStorage.removeItem(this.REFRESH_REASON_KEY);
  }
}

